// BUR symbol id of the wild (WR), which the Storm of the Buffalo feature drops in
export const WILD_ID = 1;

// MYSTERY (20) and the free spins mystery MWILD (21), as in BURReelsModel mystery_symbol_id / fs_mystery_symbol_id
export const MYSTERY_IDS = [20, 21];

export const isMystery = (id: number): boolean => MYSTERY_IDS.includes(id);

// Free spins feature with jackpots (raw server combo value)
export const JACKPOTS_FEATURE = "Yellow";
